module.exports = __webpack_public_path__ + "static/media/icon-file.a44e9b4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/FileItem/assets/icon-file.svg
// module id = 932
// module chunks = 193